module.exports = __webpack_public_path__ + "img/SDG-14-EN.fb61581a.png";